import * as CubiqTS from "shared/cubiq-model-multi-asset";

export const CHANNEL_SALES_APPROVAL_SERVICE: string = "OrderSalesApprovalRequestServiceChannel";

export interface IOrderSalesApprovalRequestService {
  requestApproval(
    ids: Array<string>,
    comment: string,
    action: CubiqTS.SalesApprovalAction,
  ): Promise<string>;
}
